export namespace INVENTORY_COST_METHOD {
    export const AVERAGE = "average"
    export const FIFO = "fifo"
    export const LIFO = "lifo"
}
export type INVENTORY_COST_METHOD = typeof INVENTORY_COST_METHOD[keyof typeof INVENTORY_COST_METHOD]




// WEBPACK FOOTER //
// ./src/state/inventory/configuration/models/types.ts